import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';
import IGridicsUseTag = ZoneIQCalibration.IGridicsUseTag;
import { CommonService } from 'src/shared/services/common.service';
import { GridicsUseTagService } from 'src/app/core/services/gridics-use-tag.service';

export interface IGridicsUseTagEditData {
    record: IGridicsUseTag;
    existingRecords: IGridicsUseTag[];
}

@Component({
    standalone: false,
    selector: 'app-gridics-use-tag-edit-popup',
    templateUrl: './gridics-use-tag-edit-popup.component.html',
    styleUrls: ['./gridics-use-tag-edit-popup.component.scss']
})
export class GridicsUseTagEditPopupComponent implements OnInit {
    isValidRecord = false;
    validationErrors = '';
    originalRecord: IGridicsUseTag;
    currentRecord: IGridicsUseTag;
    isExecuting: boolean = false;

    get isExistingLabel() {
        return !!_.get(this, 'data.record.Id');
    }

    constructor(
        private readonly commonService: CommonService,
        public readonly dialogRef: MatDialogRef<GridicsUseTagEditPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: IGridicsUseTagEditData,
        private readonly gridicsUseTagService: GridicsUseTagService
    ) {}

    ngOnInit(): void {
        this.originalRecord = this.data.record || this.getDefaultRecord();
        this.currentRecord = _.cloneDeep(this.originalRecord);
        this.checkValidation(this.currentRecord.GridicsUse);
    }

    checkValidation(value: string) {
        this.isValidRecord = true;
        this.validationErrors = '';

        if (!this.commonService.checkEmptyString(value)) {
            this.isValidRecord = false;
            this.validationErrors = 'Gridics Use label can not be empty';
            return;
        }

        const trimmedValue = value.trim();
        if (
            this.data.existingRecords.find(
                record =>
                    record.GridicsUse === trimmedValue &&
                    (!this.currentRecord.Id || (this.currentRecord.Id && record.Id !== this.currentRecord.Id))
            )
        ) {
            this.isValidRecord = false;
            this.validationErrors = 'Gridics Use Tag with current label already exists';
            return;
        }
    }

    updateRecord() {
        if (!this.isValidRecord) {
            return;
        }

        this.currentRecord.GridicsUse = this.currentRecord.GridicsUse.trim();
        this.isExecuting = true;

        const method = this.currentRecord.Id
            ? this.gridicsUseTagService.updateGridicsUseTag(this.currentRecord)
            : this.gridicsUseTagService.createGridicsUseTag(this.currentRecord);

        method.subscribe(useTag => {
            if (useTag) {
                this.dialogRef.close();
                return;
            }

            this.isValidRecord = false;
            this.validationErrors = this.currentRecord.Id
                ? 'Error when updating Gridics Use Tag'
                : 'Error when creating Gridics Use Tag';
            this.isExecuting = false;
        });
    }

    getDefaultRecord(): IGridicsUseTag {
        return {
            GridicsUse: ''
        };
    }
}
